import * as Sentry from "@sentry/browser"
import { loadEnvVars } from "../../../utils/loadEnvVars"
const { sentryDsn: dsn } = loadEnvVars()

const beforeSend: NonNullable<NonNullable<Parameters<typeof Sentry.init>[0]>["beforeSend"]> = async event => {
  const isChunkError =
    event?.exception?.values &&
    event.exception.values[0].type === "ChunkLoadError" &&
    window.location.hash !== "#chunkError" &&
    window.history

  if (isChunkError) {
    window.history.pushState(null, "chunkError", "#chunkError")
    window.location.reload()
    return null
  }

  return event
}

export const sentryInit = (isDev = false) => {
  return Sentry.init({
    dsn,
    ignoreErrors: ["FakeError"],
    environment: isDev ? "development" : "production",
    denyUrls: ["localhost:3000"],
    beforeSend,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true
      }),
      Sentry.browserTracingIntegration()
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/[^/]*-clienti\.qa\.bancacfplus\.it(?:\/|$)/,
      /^https:\/\/clienti\.bancacfplus\.it(?:\/|$)/
    ]
  })
}
